module.exports = __webpack_public_path__ + "static/img/distribute_extra.af079438.svg";